import React from 'react';
import {Link} from "react-router-dom";
import './index.css'

function CommonSection({title, breadCrumb}) {
    return (
        <div className="relative common__section w-full  flex flex-wrap text-center justify-center items-center pb-20 pt-56">
            <div className="container mx-auto text-center">
                <h1 className='text-white font-semibold relative z-30 uppercase text-5xl md:text-2xl common_title'>{title}</h1>
                {/* <div className="breadCrumb flex items-center gap-2 justify-center text-white relative z-30 mt-5 sm:flex-wrap sm:gap-1">
                    <Link to='/' className='uppercase xs:text-sm'>unicon data uz</Link>
                    &gt;
                    <h1 className='text-base uppercase xs:text-sm'>{breadCrumb}</h1>
                </div> */}
            </div>
            <div className='absolute top-0 left-0 bottom-0 right-0 bg-[#222] opacity-70'></div>
        </div>
    );
}

export default CommonSection;
